import PropTypes from 'prop-types';
import { useTranslation } from 'Shared/util/custom-hooks';
import useUserContext from 'Contexts/user-context';
import Page from 'Shared/components/page/page';
import SalesMethods from 'Pages/sales-methods/sales-methods';
import EmptyStateDescription from '../components/empty-state-description';
import styles from './default-empty-state-view.css';


const DefaultEmptyStateView = ({
  firstTimeUser,
}) => {
  const { user } = useUserContext();
  const troot = useTranslation(x => x.landing.empty_state);
  const { default: t } = troot;

  const headerText = (firstTimeUser ? troot.welcome : troot.format(t.welcome_back, { firstName: user.firstName }));
  const introductionText = (firstTimeUser ? t.introduction : t.introduction_welcome_back);

  return (
    <Page
      narrowWidth
      title={{
        text: headerText,
        reducedMarginBottom: true,
      }}
    >
      <EmptyStateDescription
        translations={troot}
        introductionText={introductionText}
        className={styles.descriptionContainer}
      />
      <SalesMethods />
    </Page>
  );
};

DefaultEmptyStateView.propTypes = {
  firstTimeUser: PropTypes.bool.isRequired,
};

export default DefaultEmptyStateView;
